var _excluded = ["children", "variant", "className", "onContainerSize", "isInverse"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import StyledTile from './tile.styles';
import { TileHead, TileBody, TileFooter } from './components';
import ContainerQuery from '../container-query';
import { TileContext } from './tile-context';
import { StyledCacheWrapper } from '../../styles';
import InverseContext from '../../utilities/inverse-context';
import withDeprecatedProps from '../../utilities/with-deprecated-props/withDeprecatedProps';
var tilePropTypes = {
  /**
   * Add Tile child components here
   */
  children: PropTypes.node,
  /** Tile border */
  hasBorder: PropTypes.bool,
  /**
   * @deprecated since 2.55.0
   * @see hasBorder
   */
  isBordered: PropTypes.bool,
  /** Top border Theme colors in tile */
  borderTop: PropTypes.oneOf(['default', 'indigo', 'navy', 'blue', 'green', 'coral', 'orange', 'red', 'violet', 'yellow']),
  /** Left border Theme colors in tile */
  borderLeft: PropTypes.oneOf(['default', 'indigo', 'navy', 'blue', 'green', 'coral', 'orange', 'red', 'violet', 'yellow', 'gray']),
  /** Tile variant */
  variant: PropTypes.oneOf(['gray', 'cool-gray', 'white', 'dark', 'brand', 'transparent']),
  /** Adds classes to the tile */
  className: PropTypes.string,
  /** Add utility objects for styling */
  utils: PropTypes.object,
  /** Callback for when component resizes */
  onContainerSize: PropTypes.func,
  /** Controls the inverse style of the tile */
  isInverse: PropTypes.bool
};
var tileDefaultProps = {
  hasBorder: false,
  isBordered: null,
  children: /*#__PURE__*/React.createElement(TileBody, null),
  borderTop: 'default',
  borderLeft: 'default',
  variant: 'white',
  className: '',
  utils: {},
  onContainerSize: function onContainerSize() {},
  isInverse: false
};

/**
 * @ignore @description
 * ## Tile Component
 * The Tile component is a content container with a white variant, faint box-shadow, and a border-radius and is primarily used as what's also know as a Card component.
 *
 * @ignore @see Mesh: [Tile Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/containers-tile--default)
 *
 * @ignore @example
 * ```jsx
 * import { Tile } from 'mesh-component-library';
 * import { useState } from 'react';
 *
 * <Tile>
 *   <Tile.Head subtitle="hello" />
 *   <Tile.Body>Body</Tile.Body>
 *   <Tile.Footer>Footer</Tile.Footer>
 * </Tile>;
 * ```
 */

export var Tile = function Tile(props) {
  var children = props.children,
    variant = props.variant,
    className = props.className,
    onContainerSize = props.onContainerSize,
    isInverse = props.isInverse,
    other = _objectWithoutProperties(props, _excluded);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    tileSize = _useState2[0],
    setTileSize = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    childIndexes = _useState4[0],
    setChildIndexes = _useState4[1];
  var memoizedContextValue = React.useMemo(function () {
    return {
      tileSize: tileSize,
      variant: !isInverse && variant,
      childIndexes: childIndexes,
      setChildIndexes: setChildIndexes
    };
  }, [isInverse, tileSize, variant, childIndexes, setChildIndexes]);
  var handleContainerSize = function handleContainerSize(size) {
    if (size.breakpoint !== tileSize.breakpoint) {
      setTileSize(size);
    }
    onContainerSize(size);
  };
  return /*#__PURE__*/React.createElement(StyledCacheWrapper, null, /*#__PURE__*/React.createElement(TileContext.Provider, {
    value: memoizedContextValue
  }, /*#__PURE__*/React.createElement(ContainerQuery, {
    onContainerSize: handleContainerSize
  }, /*#__PURE__*/React.createElement(StyledTile, _extends({}, other, {
    className: className,
    variant: variant,
    isInverse: isInverse
  }), /*#__PURE__*/React.createElement(InverseContext.Provider, {
    value: isInverse
  }, children)))));
};
Tile.Head = TileHead;
Tile.Body = TileBody;
Tile.Footer = TileFooter;
Tile.defaultProps = tileDefaultProps;
Tile.propTypes = tilePropTypes;
Tile.displayName = 'Tile';

/**
 * @type React.FC<tilePropTypes>
 */
export default withDeprecatedProps(Tile);